import type { Locale } from 'date-fns'
import {
  cs,
  de,
  el,
  enUS as en,
  es,
  fr,
  hu,
  it,
  ja,
  ko,
  nl,
  pl,
  pt,
  ptBR,
  ru,
  sk,
  sl,
  tr,
  zhCN as zh,
} from 'date-fns/locale'

import type { AppLocale } from '@/locale/types/Locale'

const dateLocales = {
  de,
  en,
  it,
  es,
  fr,
  cs,
  hu,
  ja,
  ko,
  pl,
  pt,
  sk,
  el,
  tr,
  nl,
  'pt-br': ptBR,
  ru,
  sl,
  zh,
} satisfies Record<AppLocale, Locale>

export const getDateFnsLocale = (locale: AppLocale) => dateLocales[locale]
